<template>
  <h1>buttons pages</h1>
</template>